export const OwnerTypeEnum = {
  lookupTypeId: 1229,
};
